document.addEventListener('DOMContentLoaded', function() {
  const accountLoginUrl = document.querySelector('.account_login_url');
  const myAccountDropdown = document.querySelector('.myaccount_dropdown_menu');
  let timeout;
  if (!accountLoginUrl || !myAccountDropdown) {
    console.warn('dropdown-login.js : éléments manquants, script arrêté.');
    return;
  }
  function showDropdown() {
    myAccountDropdown.classList.add('myaccount_dropdown_menu_open');
  }
  function hideDropdown() {
    myAccountDropdown.classList.remove('myaccount_dropdown_menu_open');
  }
  accountLoginUrl.addEventListener('mouseover', showDropdown);
  accountLoginUrl.addEventListener('click', function(event) {
    event.preventDefault();
    showDropdown();
  });
  function closeDropdown() {
    timeout = setTimeout(hideDropdown, 200);
  }
  function cancelCloseDropdown() {
    clearTimeout(timeout);
  }
  myAccountDropdown.addEventListener('mouseenter', cancelCloseDropdown);
  myAccountDropdown.addEventListener('mouseleave', closeDropdown);
  accountLoginUrl.addEventListener('mouseleave', closeDropdown);
});